import React from 'react';

import CurrenciesMatrix from '../../../components/CurrenciesMatrix';
import { LandingCta, LandingSection, LandingSectionHeader } from '../../components';

function CoverageSection() {
  return <LandingSection id="price-pairs">
    <LandingSectionHeader eyebrow="GoldAPI.io Price Pairs" title="Supported Currencies & Metals Coverage" description="Browse supported XAU, XAG, XPT, and XPD currency pairs instantly available by GoldAPI.io." />
    <CurrenciesMatrix />
    <LandingCta />
  </LandingSection>;
}

export default CoverageSection;
